import { render, staticRenderFns } from "./OrdersList.vue?vue&type=template&id=512f21f4&scoped=true"
import script from "./OrdersList.vue?vue&type=script&lang=ts"
export * from "./OrdersList.vue?vue&type=script&lang=ts"
import style0 from "./OrdersList.vue?vue&type=style&index=0&id=512f21f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512f21f4",
  null
  
)

export default component.exports